export { default } from './TableNewCollectionContainer';
